<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading><span *ngIf="!showPersonalContent; else personalContentHeading">Collection Access</span> </h1>
    <ng-template #personalContentHeading>Personal content access</ng-template>
    <mode-workspace-access-selector
      [isContentPersonal]="showPersonalContent"
      [selected]="overallAccess"
      (selection)="defaultAccessLevelChange($event)"
      sub-heading
    ></mode-workspace-access-selector>
  </mode-dialog-header>
</div>
<div mat-dialog-content>
  <mode-alert-banner [message]="modeAlert">
    <button
      class="secondary-button alert-action-button"
      secondary-button
      (click)="handleAlertCancelClick()">
      Cancel
    </button>
    <button
      class="primary-button alert-action-button"
      primary-button
      (click)="handleAlertRemoveAllClick()">
      Remove all
    </button>
  </mode-alert-banner>
  <div *ngIf="(loadingEntitlements$ | async) === false; else loadingAccessors">
    <div class="additional-access-header">
      <h2>Additional Access</h2>
      <capra-button
        *ngIf="(canBulkRemove$ | async) === true"
        aria-label="Remove all"
        variant="secondary"
        color="neutral"
        icon="icon-trash"
        text="Remove all&hellip;"
        (clicked)="handleRemoveAllClick()">
      </capra-button>
    </div>
    <div *ngIf="(explicitEntitlements$| async) as entitlements; else noAccessors">
      <div *ngIf="showEmptyAccess" class="collection-empty-access">
        <p *ngIf="!showPersonalContent">There are no Members with additional access to this Collection.</p>
        <p *ngIf="showPersonalContent">There are no Members with additional access to your Personal content.</p>
      </div>
      <mat-list class="collection-access-list">
        <mat-list-item
          *ngFor="let entitlement of entitlements; trackBy: getEntitlementToken"
          @fadeOut
          (@fadeOut.start)="handleAccessorFadeOutStart()"
          (@fadeOut.done)="handleAccessorFadeOutEnd()">
          <mode-accessor-name
            [avatar]="entitlement.accessor.avatar"
            [link]="entitlement.accessor.webLink"
            [name]="entitlement.accessor.name"
            [type]="entitlement.accessor.type"></mode-accessor-name>
          <mode-access-inline-toast [token]="entitlement.token" [placement]="'left'">
            <mode-access-selector
              [isContentPersonal]="showPersonalContent"
              [selected]="entitlement.action"
              [type]="selectorType"
              (selection)="entitlementChange($event, entitlement)"
              showRemove></mode-access-selector>
          </mode-access-inline-toast>
        </mat-list-item>
      </mat-list>
    </div>
    <ng-template #noAccessors>
      There are no Members with additional access to this Collection.
    </ng-template>
  </div>
  <ng-template #loadingAccessors>
    <mode-dialog-loading-view></mode-dialog-loading-view>
  </ng-template>
</div>
<div mat-dialog-actions (click)="handleAddMembersClick()">
  <span class="action-text">
    <capra-icon icon="icon-plus-default" title="Add Members"></capra-icon>
    <span>Add Members</span>
  </span>
  <capra-icon icon="icon-chevron-right"></capra-icon>
</div>
<div
  class="alert-background"
  *ngIf="displayBackground()"
  (click)="handleAlertBackgroundClick()"></div>
